/**
 * Formats project title: applies display name overrides and title case.
 * Converts hyphens to spaces and capitalizes first letter of each word.
 * @param {string} title - The project title to format
 * @returns {string} - Formatted title with proper capitalization
 */
export function formatProjectTitle(title) {
  if (!title || typeof title !== 'string') {
    return title;
  }

  // Display name overrides for specific projects (slug or title match)
  const normalized = title.toLowerCase().trim();
  if (normalized === 'blind cv' || normalized === 'blind-cv' || normalized === 'blindcv') {
    return 'Reverse Marketing';
  }

  // Remove trailing "-tool" (e.g. "smart-contact-tool" -> "smart-contact")
  let formatted = title.replace(/-tool$/gi, '');

  // Replace hyphens with spaces
  formatted = formatted.replace(/-/g, ' ');

  // Remove the word "tool" wherever it appears (e.g. "Smart Contact Tool" -> "Smart Contact")
  formatted = formatted.replace(/\s+tool\b/gi, '').replace(/\btool\s+/gi, '').trim();

  // Capitalize first letter of each word (title case)
  formatted = formatted.replace(/\b\w/g, (char) => char.toUpperCase());

  return formatted.trim();
}
